// extracted by mini-css-extract-plugin
export default {"infoBanner":"info-banner-module__infoBanner___Lh07a","message":"info-banner-module__message___T0FfI"};